import request from 'src/utils/request';

/** 登录 */
export const login = (data: any) => {
  return request.post('/api/car/admin/login/phone', data);
};
/** 双因子登录 */
export const loginWithPassword = (data: any) => {
  return request.post('/api/car/admin/login/compound', data);
};

/** 登出 */
export const logout = (data?: any) => {
  return request.delete('/api/car/admin/logout', data);
};

export type UserInfo = {
  id: number;
  name: string;
  phone: string;
  adminType: string;
  status: string;
  permissionCodes: string[];
  notice: true;
  orgId: number;
};

/** 获取当前用户信息详情 */
export const getUserInfo = (): Promise<UserInfo> => {
  return request.get(`/api/car/admin/getUserInfo`);
};
/** 获取当前用户是否弹窗 */
export const getUserModal = (id: number) => {
  return request.get(`/api/car/admin/notice/user/${id}`);
};

/** 用户分页列表 */
export const getUserPage = (params: any) => {
  return request.get(`/api/industry/monitor/sys/page`, { params });
};

/** 获取当前用户拥有的权限列表 */
export const getUserPermission = () => {
  return request.get(`/api/industry/monitor/sys/permission`);
};

/** 获取用户已分配角色ID列表 */
export const getUserRole = (id: number) => {
  return request.get(`/api/industry/monitor/sys/${id}/role`);
};

/** 保存用户分配角色 */
export const postUserRole = (id: number, data: any) => {
  return request.post(`/api/industry/monitor/sys/${id}/role`, data);
};

/** 新增用户 */
export const postUserAdd = (data: any) => {
  return request.post(`/api/industry/monitor/sys/add`, data);
};
/** 修改用户 */
export const putUserUpdate = (data: any) => {
  return request.put(`/api/industry/monitor/sys/update`, data);
};

/** 删除用户 */
export const deleteUserDel = (id: any) => {
  return request.delete(`/api/industry/monitor/sys/del?id=${id}`);
};

//发送验证码
export const sendCaptcha = (parmas: any) => request.post('/api/car/admin/captcha/phone', parmas);

//发送验证码+带图形验证码
export const sendCaptchaWithGraphic = (parmas: any) =>
  request.post('/api/car/admin/captcha/graphic/phone', parmas);

/** 修改密码 */
export const putPassword = (data: any) => {
  return request.put(`/api/car/admin/update/password`, data);
};

/** 获取当前后台样式 */
export const getBackendStyle = (params: any) => {
  return request.post(`/api/car/admin/domain/getStyleByDomain`, params);
};
